// extracted by mini-css-extract-plugin
export default {"container":"pr-z","brandName":"qr-z","productName":"rr-z","productNamePdpEnhancements":"sr-z","breakLongProductName":"tr-z"};